import React, { useEffect, useState } from "react";
import axios from "axios";
import "./transcript.css";
import AiIcon from "../Icons/aiicons";
import PersonIcon from "@mui/icons-material/Person";
import Download from "../Icons/download";
import Tooltip from "@mui/material/Tooltip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const jsonConfig = require("../../Config.json");

const Transcript = ({ id, onClose }) => {
    const [transcriptContent, setTranscriptContent] = useState([]);
    const [loading, setLoading] = useState(true);

    const goToDashboard = () => {
        onClose(false); 
    };

    useEffect(() => {
        fetchTranscript();
    }, []);

    const fetchTranscript = async () => {
        try {
            const url = `${jsonConfig.ctResourcesCdn}/screeninginterview/${id}/transcript/${id}.txt`;
            const response = await axios.get(url);

            let segments = [];

            if (response.data?.segments) {
                segments = response.data.segments;
            } else {
                const parsed = JSON.parse(response.data + "{} ] }");
                segments = parsed?.segments || [];
            }

            if (segments.length && !segments[segments.length - 1]?.text) {
                segments.pop();
            }

            setTranscriptContent(segments);
            setLoading(false);
        } catch (err) {
            console.error("Failed to fetch transcript", err);
            setLoading(false);
        }
    };

    const handleDownload = () => {
        window.open(
            `${jsonConfig.ctResourcesCdn}/screeninginterview/${id}/transcript/${id}.txt`,
            "_blank"
        );
    };

    if (loading) {
        return <div className="transcript-loading">Loading transcript...</div>;
    }

    return (
        <div className="transcript-page">

            <div className="community_header_transcript">
                <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                    <Tooltip title="Go Back to Interview Analysis" placement="bottom">
                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                    </Tooltip>
                </div>
                <div className="communityTitle">Transcript Content</div>
            </div>

            {/* BODY */}
            <div className="transcript-body ">
                {transcriptContent.map((line, index) => {
                    const isInterviewer = line.speaker === "interviewer";
                    const isCandidate = line.speaker === "candidate";

                    return (
                        <div
                            key={index}
                            className={`transcript-bubble ${
                                isInterviewer ? "interviewer" : "candidate"
                            }`}
                        >
                            <div className="icon">
                                {isInterviewer ? <AiIcon /> : <PersonIcon />}
                            </div>

                            <div className="content">
                                <div className="speaker">
                                    {isInterviewer ? "Alisha" : "Candidate"}:
                                </div>
                                <div className="message">{line.text}</div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* FOOTER */}
            <div className="transcript-footer">
                <button className="download-btn" onClick={handleDownload}>
                    <Download />
                    <span>Download</span>
                </button>
            </div>
        </div>
    );
};

export default Transcript;